import React from 'react';
import { withRouter } from 'react-router'
import Layout from './Layout';
import './PageHeaderOutline.css';

import Row from '../elements/Row';
import Readout from '../elements/Readout';
import RoundButton from '../elements/RoundButton';

class PageHeaderOutline extends Layout {


  render(){

    // Set the bottom of the header
    let bottom = null;
    if (this.props.children) {
      bottom = <div className="HeaderBottom">
        {this.props.children}
      </div>
    }

    return (
      <div className="PageHeaderOutline" data-bottom={bottom!=null}>
        <div className="HeaderTop">
          {this.props.top}
        </div>
        <div className="HeaderMiddle">
          <div className="Title">{this.props.title}</div>
          <div className="Aside">{this.props.aside}</div>
        </div>
        {bottom}
      </div>
    )
  }
}

const RoutedPageHeaderOutline= withRouter(PageHeaderOutline)
export default RoutedPageHeaderOutline;
